import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DialogService } from '../../../../services/dialog.service';
import { filled, OptionalValue } from '../../../utils/common';
import { FieldmagicDataStoreKey } from '../../../store/data-state.store';

@Component({
  selector: 'fieldmagic-dialog-close-button',
  template: `
    <fieldmagic-primary-button
      label="Close"
      icon="times"
      variant="error"
      (click)="onClick()"
      [disabled]="disabled"
    >
    </fieldmagic-primary-button>
  `,
  providers: [
    DialogService,
  ],
})
export class DialogCloseButtonComponent<C = any> implements OnInit {
  @Input() disabled: boolean = false;

  @Input() instance?: C;

  @Input() dataStateKey?: OptionalValue<FieldmagicDataStoreKey>;

  @Output('click') $onClick = new EventEmitter<void>();

  constructor(
    private readonly _dialog: DialogService,
  ) {}

  ngOnInit(): void {
    if (filled(this.instance) && filled(this.dataStateKey)) {
      this._dialog.confirmBeforeDismiss({
        instance: this.instance,
        data_state_key: this.dataStateKey,
      });
    }
  }

  onClick(): void {
    if (filled(this.instance)) {
      this._dialog.close({
        instance: this.instance,
        dismissal: {
          data_state_key: this.dataStateKey,
        },
      });
    } else {
      this.$onClick.emit();
    }
  }
}